import React, {useEffect, useState} from 'react';
import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    Tooltip,
    Typography
} from '@deere/fuel-react';
import {Controller} from "react-hook-form";
import {FeedbackComments} from "./FeedbackComments";
import {withStyles} from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import {FeedbackViewComments} from "./FeedbackViewComments";
import {NOT_APPLICABLE} from "../shared/Constants";


const StyledRating = withStyles({
    iconFilled: {
        color: '#666',
    }
})(Rating);

export const FeedbackLikertScale = ({
    criteria,
    state,
    criteriaId,
    control,
    onChange,
    item,
    ratingValue,
    commentValue,
    naValue,
    errors,
    maxStars
}) => {
    const [disabled, setDisabled] = useState(false)
    const [value, setValue] = useState(ratingValue)
    const [hover, setHover] = useState(-1);
    const [labels, setLabels] = useState({})
    const [isRatingRequired, setIsRatingRequired] = useState(true)
    // const {enqueueToast} = useToastProvider();

    const handleNotApplicable = (event) => {
        if (event.target.checked === true) {
            setDisabled(true)
            setValue(null)
            setIsRatingRequired(false)
        } else {
            setDisabled(false)
            setIsRatingRequired(true)
        }

        onChange(event.target.checked)
    }

    const handleTypeChange = (value) => {
        setValue(value);
        onChange(!!value)
    }

    const validateErrors = keyValue => {
        return Object.keys(errors).length !== 0 && Object.keys(errors).includes(keyValue)
    }

    useEffect(() => {
        if (naValue) {
            setDisabled(true)
            setIsRatingRequired(false)
        }
        let tempObj = {}
        const labelObj = item.responseType.id === 2 ? item.ratings.reduce((obj, ele) => {
            return {
                ...obj,
                [ele["level"]]: ele["description"],
            };
        }, tempObj) : item.responseType.id === 4 ? item.custLikertRanges.reduce((obj, ele) => {
            return {
                ...obj,
                [ele["order"]]: ele["label"],
            };
        }, tempObj) : tempObj;
        setLabels(labelObj)
        return () => {
            setDisabled(false);
            setIsRatingRequired(true)
        }
    }, [item, naValue]);

    return (
        <Grid container direction="row"
            justifyContent="flex-start"
            alignItems="flex-start">
            <Grid item xs={12} md={10}>
                <Typography display='inline' variant="label">
                    {criteria}{" "}
                </Typography>
                {state.responseStatus.id === 1 && (
                    <span
                        aria-label="required field"
                        className="uxf-is-required"
                    > * </span>
                )}
            </Grid>
            <Grid item xs={12} md={2}>
                <Box display="flex" justifyContent="flex-end">
                    {state.responseStatus.id === 1 && (
                        <FormControl component="fieldset">
                            <Controller
                                control={control}
                                defaultValue={naValue}
                                name={`${criteriaId}n/a`}
                                render={({onChange, value}) => (
                                    <FormControlLabel style={{marginRight: 0}}
                                        control={<Checkbox name={`${criteriaId}n/a`}
                                            defaultChecked={naValue} />}
                                        label={NOT_APPLICABLE}
                                        onChange={(e) => {
                                            onChange(e.target.checked);
                                            handleNotApplicable(e)
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    )}
                </Box>
            </Grid>
            {state.responseStatus.id === 2 ? (
                <>
                    {naValue ? (
                        <Grid item xs={12}>
                            <Typography variant="label" display="inline">
                                {NOT_APPLICABLE};
                            </Typography>
                            &nbsp; <FeedbackViewComments comments={commentValue} />
                        </Grid>
                    ) : (
                        <>
                            <Grid item xs={12}>
                                <StyledRating
                                    defaultValue={value}
                                    emptyIcon={<StarBorderIcon fontSize="inherit" />}
                                    readOnly={true}
                                    max={maxStars}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FeedbackViewComments comments={commentValue} />
                            </Grid>
                        </>
                    )}
                </>
            ) : (
                <>
                    <Grid item xs={12} md={3}>
                        <FormControl disabled={disabled} fullWidth p={2}
                            error={validateErrors(`${criteriaId}ratingStatus`)}
                            component="fieldset">
                            <Controller
                                rules={{required: isRatingRequired}}
                                control={control}
                                defaultValue={value}
                                name={`${criteriaId}ratingStatus`}
                                render={({onChange}) => (
                                    <Tooltip
                                        title={labels[hover !== -1 ? hover : value] === "" ? " No rating description " : labels[hover !== -1 ? hover : value]}
                                        placement="bottom-start" arrow={false}
                                    >
                                        <StyledRating
                                            emptyIcon={<StarBorderIcon fontSize="inherit" />}
                                            name={`${criteriaId}ratingStatus`}
                                            disabled={disabled}
                                            value={parseInt(value)}
                                            max={maxStars}
                                            size="large"
                                            onChange={(e, newValue) => {
                                                onChange(e);
                                                console.log(newValue);
                                                handleTypeChange(newValue);
                                            }}
                                            IconContainerComponent={
                                                function IconContainer(props) {
                                                    const {value, ...other} = props;
                                                    return <span {...other} />;
                                                }
                                            }
                                            onChangeActive={(event, newHover) => {
                                                setHover(newHover);
                                            }}
                                        />
                                    </Tooltip>
                                )}
                            />
                            <FormHelperText>{isRatingRequired && validateErrors(`${criteriaId}ratingStatus`) && "Please select a rating"}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={9}>
                        <FeedbackComments
                            control={control}
                            showLabel={false}
                            generalComments={commentValue}
                            name={`${criteriaId}ratingComments`}
                            disabled={disabled}
                            rowsHeight={3}
                            placeholder={`Feedback Comments ${(maxStars === 5 && value > 3) ? "(Optional)" : ""}`}
                            required={!disabled && (maxStars === 5 && value <= 3)}
                        />
                    </Grid>
                </>
            )}
        </Grid>
    )
}
